<template>
    <h3 class="text-dark mt-8 mb-4 text-2xl">
        <span class="font-bold">Top rated {{ priceRange }}&nbsp;</span>

        <template v-if="manufacturer || model.manufacturer">
            {{ manufacturer ? manufacturer.name : model.manufacturer.name }}
        </template>

        {{ model.name }} tyres
    </h3>

    <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-4">
        <template v-if="! loading">
            <template v-if="tyres.length > 0">
                <TyreCard v-for="tyre of tyres" :product="tyre"></TyreCard>
            </template>

            <p class="col-span-full" v-else>
                We have no reviews for {{ priceRange }}

                <template v-if="manufacturer || model.manufacturer">
                    {{ manufacturer ? manufacturer.name : model.manufacturer.name }}
                </template>

                {{ model.name }} tyres
            </p>
        </template>

        <template v-else>
            <TyreCardLoader :items="12"></TyreCardLoader>
        </template>
    </div>
</template>

<script>
import TyreCard from "@/Components/Products/Tyres/TyreCard";
import TyreCardLoader from "@/Components/Loaders/TyreCardLoader";

export default {
    components: {TyreCardLoader, TyreCard},
    props: {
        manufacturer: Object,
        model: Object,
        priceRange: String
    },
    data() {
        return {
            tyres: [],
            loading: false
        };
    },
    mounted() {
        this.getTyres();
    },
    methods: {
        async getTyres() {
            this.loading = true;

            const response = await axios.get(this.route("models.products.index", this.model), {
                params: {
                    price_range: this.priceRange,
                    per_page: 12
                }
            });

            this.tyres = response.data.data;

            this.loading = false;
        }
    }
};
</script>

<style scoped>

</style>
